import { Box, Typography } from '@mui/material';

type SchedulerTimeOffBlockProps = {
  title?: string | null;
};

export default function SchedulerTimeOffBlock({
  title,
}: SchedulerTimeOffBlockProps) {
  return (
    <Box
      data-testid="scheduler-time-off-block"
      sx={{
        height: '100%',
        minHeight: 64,
        display: 'flex',
        alignItems: 'center',
        px: 1.4,
        backgroundColor: '#F8FAFC',
        backgroundImage:
          'repeating-linear-gradient(45deg, rgba(148, 163, 184, 0.1) 0px, rgba(148, 163, 184, 0.1) 8px, transparent 8px, transparent 16px)',
        overflow: 'hidden',
      }}
    >
      <Typography
        data-testid="scheduler-time-off-label"
        color="#8A9BB1"
        fontSize={13}
        fontWeight={800}
        lineHeight={1.2}
        noWrap
      >
        {title || 'Unavailable'}
      </Typography>
    </Box>
  );
}
